var exports = {
  "ZA": "x4c3adb35--9c9471--suggest",
  "rg": "x4c3adb35--9c9471--suggest-item",
  "e5": "x4c3adb35--9c9471--suggest-error",
};

module.exports = exports;
